'use client';
import React from 'react';
import { MimaText, PageLayout2 } from '@/components';
import styles from '@/assets/styles/pages/home/Privacy.module.scss';

const Terms = () => {
  return (
<PageLayout2>
      <div className={styles.container}>
        <div className={styles.container_privacy}>
          <MimaText variant="h3" align="center" color="var(--color-dark)">
            Terms Of Service
          </MimaText>
          <MimaText variant="bodyBold" align="center" mt={2} mb={4}>
            Last updated on 26-04-2024
          </MimaText>
          <MimaText variant="body" mb={2}>
            Welcome to www.fashcreatives.com, a proprietary website/application of Mima 360 Limited (“Mima”, “we”, “us”). By accessing this
            Platform, you (&quot;User&quot;, “you”, “your”) agree to our terms and conditions below. We understand that legal documents may be lengthy
            and boring and most often than not you want to skip them, but it is important that you read these terms carefully before using the
            Platform. By using this Platform, you agree to be legally bound by these terms. If you do not understand any of the terms of this
            agreement, please contact us via hello@fash.style. We’re more than happy to guide you.
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            1. General Terms
          </MimaText>
          <MimaText variant="body" mb={2}>
            1.1. These terms of use govern the use of our website and mobile application (collectively called the “Platform”) and define the legally
            binding terms on which you access, browse, register or otherwise use the Platform to enjoy our services. The terms of use apply to all
            users of the Platform including guest users. <br /> <br />
            1.2. By using our Platforms in any manner, you confirm that you accept these terms of use and that you agree to comply with and be bound
            by them. <br /> <br />
            1.3. You understand that breach of any of these terms of use may result in your rights to use the services on the Platform being
            restricted, suspended or withdrawn. <br /> <br />
            1.4. We may amend these terms of use at any time by amending this page. Please check this page from time to time to take notice of any
            changes we make as they will be binding on you. <br /> <br />
            1.5. If you do not agree to these terms of use, you must not access this Platform or use the services.
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            2. Services
          </MimaText>
          <MimaText variant="body" mb={2}>
            2.1. This Platform allows users to manage their fashion business; creating an online style catalogue and easily receiving requests,
            bookings, orders and payments for their services. <br /> <br />
            2.2. Our platform showcases a diverse array of user-created catalogues, where you can explore and select your desired fashion styles from
            a multitude of options. Whether shared via users&apos; unique links or as public catalogues, these collections encompass a wide range of
            designs and trends. It&apos;s important to note that we do not claim ownership of any of these fashion styles or designs. <br /> <br />
            2.3. Mima may not be affiliated or have any form of partnerships with these style owners / fashion designers / pay. We are only
            responsible for helping you receive orders and payments, managing data which you have inputted on our platform <br /> <br />
            2.4. We operate the Platform and implement the tools and technical means to enable this relationship to work smoothly. We do not have
            possession of any fashion item. Mima is not a part or subsidiary of any of the fashion outfits that use this platform. <br />{' '}
            <br />
            2.5. We have no control over and do not guarantee the existence, quality and safety of fashion outfits advertised. We do not guarantee the
            truth or accuracy of fashion stores or designers&apos; offers and the ability of fashion designers to produce a design as described.{' '}
            <br /> <br />
            2.6. Unlike our delivery services, we cannot give any undertaking that fashion items ordered through this Platform will be of satisfactory
            quality and, this and any other such warranties (whether express or implied) are disclaimed by us to the fullest extent permitted by law.{' '}
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            3. Accessing our Platform and the Services
          </MimaText>
          <MimaText variant="body" mb={2}>
            3.1. We do not guarantee that our Platforms or any of the Services, will always be available, uninterrupted or fault free. We will not be
            liable to any user of the Platform if for any reason the Platform is unavailable at any time or for any period.
            <br /> <br />
            3.2. We do not guarantee that our Platform or any content on it will be free from errors or omissions.
            <br /> <br />
            3.3. You are responsible for making all arrangements necessary to have access to our Platforms and for ensuring that all persons who
            access the Platform through your user profile are aware of these terms of use and other applicable terms and conditions, and that they
            comply with them. <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            4. Membership and Registration
          </MimaText>
          <MimaText variant="body" mb={2}>
            4.1. Our services are available only to and may only be used by individuals who are 18 years and older and who can form legally binding
            contracts under applicable law. You represent that you are at least 18 years old and that all registration information you submit is
            accurate and truthful. <br /> <br />
            4.2. Users who fulfill the requirements above must create an account in accordance with clause 4.3 below. <br /> <br />
            4.3. In order to create an account, you must provide a full name, email address, telephone number, businesss address. A one time password
            will be provided to the User upon signing up. inputting the one time password confirms you agree with our terms of use and privacy policy.
            <br /> <br />
            4.4. You are solely responsible for keeping your login details confidential and must not disclose or share it with anyone. You will be
            responsible for all activities that take place using your login information. In the event of theft, loss or unauthorized use of a user’s
            password or account, you must contact us immediately at hello@fash.style.
            <br /> <br />
            4.5. Once you create an account, you will be able to create styles, manage measurements, create an online style catalog, receive certain
            payments for bookings or style orders via the online catalog .<br /> <br />
            4.6. Where we have reason to suspect or believe that there has or is likely to be a security breach or other misuse of our Platform, we
            reserve the right to require you to change your password. Failure to do so may result in us suspending or deleting your account. <br />{' '}
            <br />
            4.7. As a user, you: represent and understand that all account information provided is accurate, up to date, honest and not misleading;
            commit to updating your account information as and when it changes; and accept sole responsibility for any direct or indirect adverse
            consequences caused by the inaccuracy of this information or failure to update this information. <br /> <br />
            4.8. The information submitted to create or update an account constitutes a proof of your identity. We reserve the right to verify, at any
            time the accuracy of the information provided and to ask you for any additional documentation for the purpose of identity verification.{' '}
            <br /> <br />
            4.9. You can decide at any time to terminate your account, in which case your details will be deleted from the Platform.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            5. Payment
          </MimaText>
          <MimaText variant="body" mb={2}>
            5.1. All payments made on our Platform are processed by a third-party payment processor which provides a gateway for online payments.
            <br /> <br />
            5.2. In order for users to successfully receive orders, payment for orders are made through a debit card; or through bank transfers; or
            any other payment methods/channels our payment service partners may provide from time to time.
            <br /> <br />
            5.3. The payment processor is solely responsible for all payment transactions consummated on our Platform.
            <br /> <br />
            5.4. The sale prices of styles are displayed in the offers of your unique online style catalog. They are given in Naira and other
            currencies we process. They include any tax applicable taxes.
            <br /> <br />
            5.5. The total price is stated in the offer at checkout and is due for payment when the order is placed.
            <br /> <br />
            5.6. All payment received on your behalf are accessible in your digital wallet and can been withdrawn as you the user deems fit.
            <br /> <br />
            5.7. Payment withdrawals may come with charges as deemed fit by our payment partners and Platform
            <br /> <br />
            5.8. By creating an account, you agree to be bound by these terms of payment
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            6. Intellectual Property
          </MimaText>
          <MimaText variant="body" mb={2}>
            6.1. We and our partners own all intellectual property rights in the Platform and any materials published on it, except for user-generated
            content. User-generated content, including fashion styles created by users, public catalogues remains the property of the respective
            creators. These rights are protected under applicable copyright laws, and all such rights are reserved. You may only access and use the
            materials for personal use, and you may not otherwise reproduce, distribute, publicly display, or modify them without a license from us or
            the respective creators.
            <br /> <br />
            6.2. We own or are the licensor of all rights, titles, interests, in and to the Platform including all rights under patents, copyrights,
            design rights, trade secrets, and any and all other proprietary rights. Any disassembling, decryption, extraction, re-use, re-engineer,
            reverse engineer, copying or more generally any act of reproduction, representation, transmission or use of any of these elements, in part
            or in whole, without the authorization of the company is strictly prohibited and may be result in legal action.
            <br /> <br />
            6.3. If you believe the content of our Platform may have infringed on your copyright in any manner, kindly contact us and we will
            immediately take steps to stop or remedy such breach.
            <br /> <br />
            6.4. You acknowledge that words and terms used to describe the styles listed were provided to us by you users who have requested that we
            create online catalogues on your behalf. Mima will not be liable for any inappropriate or inaccurate use of style names on this
            Platform. Kindly contact us if you believe a style has been wrongly described and we will immediately take steps to remedy the same.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            7. No Reliance
          </MimaText>
          <MimaText variant="body" mb={2}>
            The content on our Platform was provided for general information only and is not intended to amount to advice on which you should rely.
            Although we make reasonable efforts to update the information on our site, we make no representation or guarantee, whether express or
            implied, that the content on our website/application is complete or up-to-date and you acknowledge that any reliance on such information
            will be at your own risk.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            8. Limitation of Liability
          </MimaText>
          <MimaText variant="body" mb={2}>
            8.1. Nothing in these terms of use excludes or limits our liability for personal injury arising from our negligence or fraudulent
            misrepresentation or any other liability that cannot be excluded or limited by Nigerian law.
            <br /> <br />
            8.2. To the extent permitted by law, we exclude all conditions, warranties, representations or other terms which may otherwise apply to
            our Platform or any content on it, whether express or implied.
            <br /> <br />
            8.3. We assume no responsibility for the content of websites linked to our Platform. Such links should not be interpreted as endorsement
            by us of those linked websites. We will not be liable for any loss or damage that may arise from your use of them.
            <br /> <br />
            8.4. As a user, please note that we only provide our Platform for while we provide our services for commercial or business purposes, we
            have no liability to you for any loss of profit or loss of business opportunity.
            <br /> <br />
            8.5. To the extent permitted by the law, Mima shall not be liable to you for any indirect punitive, incidental, special or
            exemplary damages arising out of your inability to use our Services.
            <br /> <br />
            8.6. We are not liable for any damage which may be incurred by you from unauthorized use of, tampering or access to your Mima
            account.
            <br /> <br />
            8.7. Mima is not liable and you agree not to hold Mima liable for any damages or losses resulting either directly or
            indirectly from: delays or disruptions in our Services, software, and Platform; your use or inability to use or access our Services or
            Platform; a suspension or other actions taken with your Mima account; any access or use of our services in a manner that is
            inconsistent with this terms of use or any error, inaccuracies, losses or omissions in or to any data provided to us; and any damage
            caused by a virus or other technologically harmful material that may infect your electronic devices due to the use of our Platform or any
            website linked to it.
            <br /> <br />
            8.8. We will not be liable to any user for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty,
            or otherwise, even if foreseeable arising in connection with use of or inability to use our Platform. <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            9. Indemnification
          </MimaText>
          <MimaText variant="body" mb={2}>
            9.1. You agree to indemnify, defend and hold Mima harmless against any loss, damage, liability and claim due to or arising out
            of your Use or misuse of our Services; and breach of these terms of use or any applicable law. <br /> <br />
            9.2. We reserve the right at your expense to assume the exclusive defence and control of any matter for which you are required to
            indemnify us, and you agree to cooperate with our defense of such claims. <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            10. Term and Termination
          </MimaText>
          <MimaText variant="body" mb={2}>
            This term of use becomes effective from the date you start using our services and continues until it is terminated by either you (through
            the closing of your account) or us.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            11. Restricted Activities
          </MimaText>
          <MimaText variant="body" mb={2}>
            11.1. Our Platform must be used only for lawful purposes. You must not, and must not allow another person to use it for any purpose other
            than which we made it available. <br /> <br />
            11.2. As a user of our Services and Platform, you agree not to use them: in a way that breaches the provision of any applicable law or
            regulation; in a way that is not authorized by us or detrimental to us; for any fraudulent purpose or act (Including provision of false
            identification); and to modify, adapt, decipher, disassemble or reverse engineer any of the software making up a part of our Platform.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            12. Electronic Communication
          </MimaText>
          <MimaText variant="body" mb={2}>
            12.1. By accessing and using our Services, you consent to receiving electronic communications, and that all notices, disclosures and other
            communications we provide to you electronically through emails or displayed on our Platform satisfy any legal requirement for written
            communications. <br /> <br />
            12.2. You agree to the use of electronic signatures, contracts, orders and other records and to electronic delivery of records of
            transactions initiated or completed by you. You waive the rights or requirements of any law in any jurisdictions which require original
            signature, or delivery or retention of non-electronic records
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            13. Severability
          </MimaText>
          <MimaText variant="body" mb={2}>
            If any of these terms of use are determined by any competent authority to be invalid, unlawful or unenforceable to any extent, such term,
            condition or provision will to that extent be severed from the remaining terms, conditions and provisions which will continue to be valid
            to the fullest extent permitted by Nigerian law.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            14. Personal Data
          </MimaText>
          <MimaText variant="body" mb={2}>
            The company collects and processes users’ personal data. For further details, every user is encouraged to read the Platform’s “Privacy
            Policy” . For the avoidance of doubt, with the exception of our payment provider, we do not share your details with any other third
            parties.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            15. Sanctions of Breaches
          </MimaText>
          <MimaText variant="body" mb={2}>
            15.1. In the event of any fraud, breach of these terms of use or violation of applicable laws or regulations, we reserve the right to take
            any appropriate measure, including without limitation: suspending or terminating access to all or part of the services of the user who
            committed the breach; or alerting all relevant authorities and taking legal action. <br /> <br />
            15.2. Any suspension or termination shall take full effect on the date we send the communication to the user and the user’s account will
            be automatically deleted without further notice.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            16. Complaints
          </MimaText>
          <MimaText variant="body" mb={2}>
            Users are to submit complaints to the customer service via the chat box on the mobile application or any of our social media channels.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            17. Disclaimer
          </MimaText>
          <MimaText variant="body" mb={2}>
            The services are provided “As Is” and “As Available”. Mima disclaims all representations and warranties, express, implied or
            statutory, not expressly set out in these terms. Mima makes no representation of having an existing relationship, engagement or
            commitment with any of the style designer listed on the platform. In addition, Mima makes no representation, warranty, or
            guarantee regarding the reliability, timeliness, quality, suitability or availability of the Services or any services or goods requested
            through the use of the Services, or that the Services will be uninterrupted or error-free. You agree that the entire risk arising out of
            your use of the Services, and any service or good requested in connection with it, remains solely with you, to the maximum extent
            permitted under applicable law.
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            18. Promotional Codes
          </MimaText>
          <MimaText variant="body" mb={2}>
            Mima may at Mima’s sole discretion, create promotional codes that may be redeemed for purchase discount, or other
            features or benefits related to the Services ,subject to any additional terms that Mima establishes on a per promotional code
            basis (“Promo Codes”).You agree that Promo Codes: <br /> <br />
            18.1. must be used for the intended purpose, and in a lawful manner; <br /> <br />
            18.2. may not be duplicated, sold or transferred in any manner, or made available to the general public (whether posted to a public form
            or otherwise); <br /> <br />
            18.3. may be disabled by Mima at any time for any reason without liability to Mima; <br /> <br />
            18.4. may only be used pursuant to the specific terms that Mima establishes for such Promo Code; <br /> <br />
            18.5. are not valid for cash; and <br /> <br />
            18.6. may expire prior to your use. <br /> <br />
            18.7. Mima reserves the right to withhold or deduct credits or other features or benefits obtained through the use of Promo
            Codes by you or any other user in the event that Mima determines or believes that the use or redemption of the Promo Code was in
            error, fraudulent, illegal, or in violation of the applicable Promo Code terms or these Terms
            <br /> <br />
          </MimaText>

          <MimaText variant="subtitleBold" mb={2}>
            19. Region
          </MimaText>
          <MimaText variant="body" mb={2}>
            These terms of use are governed by the Nigerian law. In the event of a dispute regarding the validity, interpretation and/or execution of
            these terms, the parties submit to the exclusive jurisdiction of the Nigerian courts.
            <br /> <br />
          </MimaText>
        </div>
      </div>
</PageLayout2>
  );
};

export default Terms;
